/* eslint-disable */
import Vue from 'vue';
import { setInteractionMode, ValidationObserver, ValidationProvider } from 'vee-validate';
import './rules/alpha_num';
import './rules/alpha_spaces';
import './rules/between';
import './rules/email';
import './rules/minmax';
import './rules/required';
import './rules/password';
import './rules/includes';
import './rules/min';
import './rules/max';
import './rules/min_number';
import './rules/confirmed';
import './rules/realm';

setInteractionMode('eager');

Vue.component('ValidationProvider', ValidationProvider);
Vue.component('ValidationObserver', ValidationObserver);
